export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/nvrDecode.worker.0b1ffee4.worker.js");
}
